import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=74836e57&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74836e57')) {
      api.createRecord('74836e57', component.options)
    } else {
      api.reload('74836e57', component.options)
    }
    module.hot.accept("./BannerItem.vue?vue&type=template&id=74836e57&", function () {
      api.rerender('74836e57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/home/components/BannerItem.vue"
export default component.exports